import {$safeApply} from '@buildium/angularjs-core/dist/utilities/angularjs';

export function TwoFactorAuthenticationVerificationController(
    $scope,
    $stateParams,
    $window,
    ApiError,
    deviceFingerprint,
    twoFactorAuthenticationConfiguration,
    PublicTwoFactorAuthenticationApi,
    TwoFactorAuthenticationMethod,
    RedirectToLoginService,
    isTwilioServiceEnabled,
    isSmsServiceEnabled,
    isVoiceServiceEnabled,
    isVerifyApiServiceEnabled,
    isSmsVoiceServiceEnabled,
    BASE_PATH_APP,
    BASE_PATH_PUBLIC
) {
    const vm = this;
    vm.deviceFingerprint = deviceFingerprint;
    vm.twoFactorAuthenticationConfiguration = twoFactorAuthenticationConfiguration;
    vm.showTwoFactorVerification = false;
    vm.isTwilioServiceEnabled = isTwilioServiceEnabled;
    vm.isSmsServiceEnabled = isSmsServiceEnabled;
    vm.isVoiceServiceEnabled = isVoiceServiceEnabled;
    vm.isVerifyApiServiceEnabled = isVerifyApiServiceEnabled;
    vm.isSmsVoiceServiceEnabled = isSmsVoiceServiceEnabled;

    vm.sid = undefined;

    function sendCodeIfNeeded() {
        // Check if the user has an authenticator app configured as default method.
        const hasAuthAppAsDefaultMethod = vm.twoFactorAuthenticationConfiguration.DefaultAuthorizationMethod === TwoFactorAuthenticationMethod.AuthApp;

        // We only need to send a code in case the user's default method is not an authenticator app.
        if (!hasAuthAppAsDefaultMethod) {
            PublicTwoFactorAuthenticationApi
                .sendCode({ token: $stateParams.token })
                .then(function(result) { vm.sid = result.VerificationSid; })
                .catch(ApiError.notify);
        }
    }

    function redirectAfterValidation(userToken) {
        const returnUrl = ($stateParams.returnUrl || $stateParams.ReturnUrl) || `${BASE_PATH_APP}/homepage/dashboard`;
        let redirectUrl = `${BASE_PATH_PUBLIC}/authentication/login-with-token?userToken=${userToken}&returnUrl=${returnUrl}`;
        if ($stateParams.isMobileApplication) {
            redirectUrl += `&isMobileApplication=${$stateParams.isMobileApplication}`;
        }
        $window.location.assign(redirectUrl);
    }

    function initialize() {
        if (vm.twoFactorAuthenticationConfiguration) {
            // Due to the way the dependencies are resolved, we might not have a configuration at all or
            // we might not have it because we did not request one due to the fact that the
            // device is being remembered.
            vm.showTwoFactorVerification = true;
            sendCodeIfNeeded();
        }
    }

    vm.redirectToLogin = function redirectToLogin() {
        RedirectToLoginService.redirect();
    };

    vm.verifyCode = function verifyCode(code, rememberDevice, onCodeVerifiedCallback) {
        const request = {
            sid: vm.sid,
            token: $stateParams.token,
            verificationCode: code,
            deviceFingerprint: vm.deviceFingerprint,
            rememberDevice
        };

        PublicTwoFactorAuthenticationApi.verifyCode(request)
            .then(result => {
                if (result.IsSuccess) {
                    redirectAfterValidation(result.Token);
                }

                onCodeVerifiedCallback(result.IsSuccess);
            })
            .catch(error => {
                if (error.data.ErrorCode && error.data.ErrorCode === '202') {
                    onCodeVerifiedCallback(false, true);
                } else if (error.data.ErrorCode && error.data.ErrorCode === '228') {
                    onCodeVerifiedCallback(false, false, true);
                } else {
                    ApiError.notify(error);
                }
            })
            .finally(() => {
                $safeApply($scope);
            });
    };

    vm.alternativeOptionSelected = function alternativeOptionSelected(option, onSuccessCallback) {
        const request = {
            token: $stateParams.token,
            provider: option.provider,
            usePrimaryPhoneNumber: option.primaryPhoneNumber
        };

        PublicTwoFactorAuthenticationApi.sendCodeUsingAlternativeMethod(request)
            .then(result => {
                vm.sid = result.VerificationSid;
                onSuccessCallback();
            })
            .catch(ApiError.notify)
            .finally(() => {
                $safeApply($scope);
            });
    };

    initialize();
}

TwoFactorAuthenticationVerificationController.$inject = [
    '$scope',
    '$stateParams',
    '$window',
    'ApiError',
    'deviceFingerprint',
    'twoFactorAuthenticationConfiguration',
    'PublicTwoFactorAuthenticationApi',
    'TwoFactorAuthenticationMethod',
    'RedirectToLoginService',
    'isTwilioServiceEnabled',
    'isSmsServiceEnabled',
    'isVoiceServiceEnabled',
    'isVerifyApiServiceEnabled',
    'isSmsVoiceServiceEnabled',
    'BASE_PATH_APP',
    'BASE_PATH_PUBLIC'
];
